import React from 'react';

export const About = () => {
  return (
    <div>
      <h1>About</h1>
      <p>Search Github users</p>
      <p>Version 1.0.0</p>
    </div>
  );
};

export default About;
